import Vue from 'vue';
import Vuex from 'vuex';
import order from './modules/order';
import user from './modules/user';
import license from './modules/license';
import report from './modules/report';
import template from './modules/template';
import frame from './modules/frame';
import project from './modules/project';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    order,
    user,
    license,
    report,
    template,
    frame,
    project,
  },
  strict: debug,
});
